import { render } from "./Change-user-password.vue?vue&type=template&id=b23f6fb8"
import script from "./Change-user-password.vue?vue&type=script&lang=js"
export * from "./Change-user-password.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__